import { render, staticRenderFns } from "./AdminRelatedServices.vue?vue&type=template&id=05ba3a81"
import script from "./AdminRelatedServices.vue?vue&type=script&lang=js"
export * from "./AdminRelatedServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports